import { Box, Grid, InputAdornment, Typography } from "@material-ui/core";
import { Formik } from "formik";
import FormSelect from "../../../../../forms/formik/FormSelectField";
import FormTextInput from "../../../../../forms/formik/FormTextInput";
import ScrollToFirstError from "../../../../../forms/formik/ScrollToFirstError";
import SubmitButton from "../../../../../forms/formik/FormSubmitButton";

import { Fragment } from "react";
import { convertToInr } from "../../../../../../utils/cart";

import { FormRadio } from "../../../../../forms/formik/FormRadioField";
import CustomButton from "../../../../../forms/CustomButton";
import CardComponent from "../../lib/CardComponent";
import Image from "../../../../../Image";
import { AddToCartStatusModal } from "../../../../customModal";
import useNewPurchase, { validationSchema } from "./useNewpuchase";
import FormCheckbox from "../../../../../forms/formik/FormCheckbox";
import { YES } from "../../../../../../store/types";
import { categoryOptions } from "../..";

const LIC_MUTUALFUND = "102";
const TRUST_MUTUALFUND = "185";
const cartDisabledFunds = [LIC_MUTUALFUND, TRUST_MUTUALFUND];

export default function NewPurchase() {
  const {
    handleCategoryChange,
    handleSchemeChange,
    handleComboSwitch,
    handleSubArnChange,
    onSubmit,
    addToCart,
    options,
    handleAmcChange,
    initialValues,
    pan,
    modalDetails,
    history,
  } = useNewPurchase();

  return (
    <Fragment>
      <Grid container>
        <Grid item lg={9} sm={12}>
          <div className="m2 vertical-stepper-body-new-investor-flow">
            <div className="vertical-stepper-body-new-investor-flow">
              <div className="d-flex" style={{ marginRight: 12 }}>
                <div
                  style={{
                    border: "1px solid ",
                    borderColor: "#003D78",
                    height: "40px",
                    width: "40px",
                    borderRadius: "20px",
                    margin: "0px 15px 10px 0px",
                  }}
                >
                  <Image
                    src={"/images/connect.png"}
                    alt="nav"
                    style={{
                      height: "20px",
                      marginTop: "8px",
                      marginLeft: "10px",
                    }}
                  />
                </div>
                <div
                  className="d-flex flex-column"
                  style={{ marginRight: "10px" }}
                >
                  <span
                    style={{ color: "gray", fontWeight: 500, fontSize: "12px" }}
                  >
                    Step 1
                  </span>
                  <span
                    style={{
                      color: "#003D78",
                      fontWeight: 600,
                    }}
                  >
                    New Purchase (lumpsum) Scheme Details
                  </span>
                </div>
              </div>
            </div>
          </div>
          <CardComponent title="Scheme Details">
            <Formik
              onSubmit={onSubmit}
              initialValues={initialValues}
              validationSchema={validationSchema}
              validateOnChange
            >
              {({ values, setValues, handleSubmit, ...helpers }) => (
                <Box component="form" onSubmit={handleSubmit}>
                  <ScrollToFirstError />
                  <AddToCartStatusModal
                    message={`Transaction has been added to cart successfully with the reference number ${modalDetails.ihNo} and bulk-order ID ${modalDetails.bulkOrderId}`}
                    open={modalDetails.isOpen}
                    image={"/images/cart_success.svg"}
                    btn_one={"Go to cart"}
                    btn_two={"Add more"}
                    history={history}
                    pan={pan}
                    onAddTransaction={() => {
                      history.push(`/cart/add-transaction/new-purchase`, {
                        pan,
                      });
                    }}
                  />

                  <FormSelect
                    name="amc"
                    label="AMC"
                    placeholder="Select AMC"
                    options={options.funds}
                    onChange={handleAmcChange(values, setValues)}
                  />
                  <FormSelect
                    name="category"
                    label="Category"
                    placeholder="Select Category"
                    options={options.categoryOptions}
                    onChange={handleCategoryChange(values, setValues)}
                  />
                  <FormSelect
                    name="scheme"
                    label="Scheme"
                    placeholder="Select Scheme"
                    options={options.schemeOptions}
                    onChange={handleSchemeChange(values, setValues)}
                  />
                  {(() => {
                    const selectedScheme = options.schemeOptions.find(
                      (scheme) => scheme.value === values.scheme
                    );

                    return (
                      selectedScheme &&
                      selectedScheme.combo_flag === YES && (
                        <Fragment>
                          <FormCheckbox
                            label="Purchase Cum Switch"
                            name="combo"
                            onChange={handleComboSwitch(values, setValues)}
                            // onClick={handleCombo}
                          />
                          <div
                            style={{
                              color: "#283d7c",
                              fontSize: 14,
                              fontFamily: "OpenSans-SemiBold",
                              margin: 10,
                            }}
                          >
                            {selectedScheme.combo_disclaimer}
                          </div>
                        </Fragment>
                      )
                    );
                  })()}
                  <FormTextInput
                    name="amount"
                    label={
                      values.minAmount
                        ? `Investment Amount (Minimum ${convertToInr(
                            values.minAmount
                          )})`
                        : "Investment Amount"
                    }
                    placeholder="Enter Investment Amount"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          {"\u20B9"}
                        </InputAdornment>
                      ),
                    }}
                    type="number"
                  />
                  <FormRadio
                    name="invCategory"
                    label="Investor Category"
                    options={categoryOptions.map((option) => ({
                      label: option.name,
                      value: option.value,
                    }))}
                  />

                  <FormSelect
                    name="emailFamily"
                    label="Email Family Description"
                    placeholder="Select family Description"
                    options={options.family}
                  />
                  <FormTextInput
                    name="email"
                    label="Email ID"
                    placeholder="Email ID"
                  />
                  <FormTextInput
                    name="mobile"
                    label="Phone No"
                    placeholder="Mobile Number"
                  />
                  <FormSelect
                    name="mobileFamily"
                    label="Mobile Family Description"
                    placeholder="Select family Description"
                    options={options.family}
                  />

                  <FormTextInput
                    name="arnCode"
                    label="ARN Code"
                    placeholder="ARN Code"
                    disabled
                  />
                  <FormTextInput
                    name="subArn"
                    label="Sub ARN Code"
                    placeholder="Sub ARN Code"
                    onBlur={handleSubArnChange(values, setValues)}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">ARN - </InputAdornment>
                      ),
                    }}
                  />
                  <FormTextInput
                    name="subBrokerCode"
                    label="Sub Broker Code"
                    placeholder="Sub Broker Code"
                  />
                  <FormRadio
                    name="euinDeclaration"
                    label="EUIN"
                    options={[
                      {
                        label: "Yes",
                        value: "Yes",
                      },
                      {
                        label: "No",
                        value: "No",
                      },
                    ]}
                  />
                  {values.euinDeclaration === "Yes" ? (
                    <FormSelect
                      name="euin"
                      label="EUIN"
                      options={options.euinOptions}
                    />
                  ) : (
                    <Typography
                      style={{
                        color: "rgba(128, 128, 128, 0.7)",
                      }}
                    >
                      I/We hereby confirm that the EUIN box has been
                      intentionally left the blank by me/us as this is an
                      'execution-only' transaction without any interaction or
                      advice by any personnel of the above distributor or
                      notwithstanding the advice of in-appropriateness,if any
                      provided by any personnel of the distributor and the
                      distributor has not charged any advisory fees on this
                      transaction
                    </Typography>
                  )}
                  <Box
                    style={{
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    {!(cartDisabledFunds.includes(values.amc)&&values.combo)? (
                      <CustomButton
                        label="Add to Cart"
                        variant="outlined"
                        onClick={() => addToCart(values, helpers)}
                      />
                    ) : null}
                    <SubmitButton label={"Submit"} variant="contained" />
                  </Box>
                </Box>
              )}
            </Formik>
          </CardComponent>
        </Grid>
      </Grid>
    </Fragment>
  );
}
